import { render, staticRenderFns } from "./LetterPreview.vue?vue&type=template&id=1280a302"
import script from "./LetterPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports